webpackJsonp([207255014926399],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = NewsletterSignup;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NewsletterSignup() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'pa4-l' },
	    _react2.default.createElement(
	      'form',
	      { className: 'bg-light-gray mw7 center pa4 br2-ns ba b--black-10' },
	      _react2.default.createElement(
	        'fieldset',
	        { className: 'cf bn ma0 pa0' },
	        _react2.default.createElement(
	          'legend',
	          { className: 'pa0 f5 f4-ns mb3 black-80' },
	          'Sign up for our newsletter, to get updated as we add more goals'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cf' },
	          _react2.default.createElement(
	            'label',
	            { className: 'clip', htmlFor: 'email-address' },
	            'Email Address'
	          ),
	          _react2.default.createElement('input', {
	            className: 'f6 f5-l input-reset bn fl black-80 bg-white pa3 lh-solid w-100 w-75-m w-80-l br2-ns br--left-ns',
	            placeholder: 'Your Email Address',
	            type: 'text',
	            name: 'email-address',
	            id: 'email-address'
	          }),
	          _react2.default.createElement('input', {
	            className: 'f6 f5-l button-reset fl pv3 tc bn bg-animate bg-black-70 hover-bg-black white pointer w-100 w-25-m w-20-l br2-ns br--right-ns',
	            type: 'submit',
	            value: 'Subscribe'
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewsletterSignup = __webpack_require__(42);
	
	var _NewsletterSignup2 = _interopRequireDefault(_NewsletterSignup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'mw9 center' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Be healthy'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'f3 i' },
	        'Guide coming soon'
	      ),
	      _react2.default.createElement(_NewsletterSignup2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-goals-be-healthy-js-04f850c5eef5dcfef206.js